export const flags = {
  hasRepoxApps: true,
  hasTranslation: true,
};
